import React from 'react';
import PropTypes from 'prop-types';

import { nanoid } from 'nanoid'
import displayName from 'component-lib/displayName';

import MenuItem from './MenuItem';

import styles from './Submenu.scss';

export default function Submenu({ links }) {
    return (
        <ol className={styles['left-hand-nav-submenu']}>
            {
                links.map(link => <MenuItem key={nanoid()} {...link} />,)
            }
        </ol>
    );
}

Submenu.displayName = displayName('LeftHandNav/Submenu');

Submenu.propTypes = {
    links: PropTypes.array.isRequired,
};
